import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const RevenueByUtmTab: React.FC = () => (
  <LookerEmbedTab
    path="dashboards/498"
    translationKey="revenue.tabs.revenue_by_utm"
  />
)

export default RevenueByUtmTab
